import { colors, grid_breakpoints } from "../../../../../../../theme/theme";
import styled from "styled-components";

export const OrderTabsWrapper = styled.div`
	width: 100%;
	display: flex;
	gap: 24px;
	border-bottom: 1px solid ${colors.greyscale.light_grey};
	overflow-x: auto;

	@media (max-width: ${grid_breakpoints.sm}) {
		gap: 0;

		.hide-on-sm {
			display: none;
		}
	}
`;
export const HeaderButton = styled.button`
	cursor: pointer;
	font-weight: 400;
	font-size: 18px;
	display: flex;
	justify-content: center;
	min-width: 100px;
	color: ${colors.greyscale.darker_grey2};
	padding-bottom: 8px;
	border: 0;
	border-bottom: 3px solid transparent;
	background: transparent;

	&.active {
		color: ${colors.mainColors.blueberry};
		border-bottom: ${`3px solid ${colors.mainColors.blueberry}`};
	}

	@media (max-width: ${grid_breakpoints.md}) {
		font-size: 16px;
	}
`;
